const formatPrice = (isoCode, value) => {
	return new Intl.NumberFormat(isoCode === 'EUR' ? 'de-DE' : 'en-US', {
		style: 'currency',
		currency: isoCode
	}).format(value)
}

export default formatPrice
